import { PageOrderEnum } from "@/lib/enum/pageOrder.enum";

import { Action, Module, Mutation, getModule } from "vuex-module-decorators";
import store from "../VuexPlugin";
import { BasePagination, FilterTypes, IPaginationFilterListElement } from "./base-pagination.store";
import {
  MrfiktivCreateUserDtoGen,
  MrfiktivPartnerUserControllerFindAllByPartnerIdParamsGen,
  MrfiktivShortUserViewModelGen,
  MrfiktivUserIdentityViewModelGen,
  MrfiktivUserViewmodelGen
} from "@/services/mrfiktiv/v1/data-contracts";
import PartnerUserService from "@/services/shared/partnerUserService";

@Module({
  dynamic: true,
  namespaced: true,
  name: "partnerUser",
  store
})
export class PartnerUserStore extends BasePagination<
  MrfiktivShortUserViewModelGen,
  MrfiktivPartnerUserControllerFindAllByPartnerIdParamsGen
> {
  protected _pageOrder: PageOrderEnum = PageOrderEnum.DESCENDING;
  protected _itemsPerPage = 100;
  protected _totalPages = 0;
  protected _paginationList: MrfiktivShortUserViewModelGen[] = [];
  protected _currentPage = 1;
  protected _totalItems = 0;
  protected _isLoadAll = false;
  filterOptions: IPaginationFilterListElement[] = [
    { key: "userName", type: FilterTypes.STRING },
    { key: "firstName", type: FilterTypes.STRING },
    { key: "lastName", type: FilterTypes.STRING },
    { key: "id", type: FilterTypes.OBJECT_ID }
  ];

  private _userIdMap = new Map<string, MrfiktivShortUserViewModelGen>();
  protected _documentMapConfig = { id: this._userIdMap };

  @Action
  protected async loadDocuments(data: MrfiktivPartnerUserControllerFindAllByPartnerIdParamsGen): Promise<any> {
    return PartnerUserService.findAll(data);
  }

  private _user: MrfiktivUserViewmodelGen | null = null;
  private _userStatus: MrfiktivUserIdentityViewModelGen | null = null;

  get user() {
    return this._user;
  }

  get userStatus() {
    return this._userStatus;
  }

  @Mutation
  mutateUser(user: MrfiktivUserViewmodelGen) {
    this._user = user;
  }

  @Mutation
  mutateUserStatus(userStatus: MrfiktivUserIdentityViewModelGen) {
    this._userStatus = userStatus;
  }

  @Action
  async findOneByPartner(data: { partnerId: string; id: string }): Promise<MrfiktivUserViewmodelGen> {
    const user = await PartnerUserService.findOne(data.partnerId, data.id);
    this.context.commit("mutateUser", user);

    return user;
  }

  @Action
  async getUserStatus(data: { partnerId: string; id: string }): Promise<MrfiktivUserIdentityViewModelGen> {
    const user = await PartnerUserService.getStatus(data.partnerId, data.id);
    this.context.commit("mutateUserStatus", user);

    return user;
  }

  @Action
  async createOneByPartner(data: {
    partnerId: string;
    resourceId: string;
    data: MrfiktivCreateUserDtoGen;
  }): Promise<MrfiktivUserViewmodelGen> {
    const user = await PartnerUserService.create(data.partnerId, data.data);
    this.context.commit("mutateUser", user);
    return user;
  }

  @Action
  async removeOneByPartner(data: { partnerId: string; id: string }): Promise<MrfiktivUserViewmodelGen> {
    const user = await PartnerUserService.remove(data.partnerId, data.id);
    this.context.commit("mutateUser", user);
    return user;
  }
}

export const PartnerUserModule = getModule(PartnerUserStore);
